import 'imagesloaded';
import 'jquery-ui/ui/widgets/draggable';

if($('.js-clicker').length > 0) {
  // variables
  let x,
      y,
      clicks = 1,
      current = 1,
      container = $('.js-clicker'),
      list = $(container).children('figure').length,
      isDragging = false;

  // touch or click device?
  function is_touch_device() {
    return 'ontouchstart' in window
      || 'onmsgesturechange' in window;
  }

  // detect if is mobile
  if(is_touch_device() != true) {
    console.log('click');
    $(container).children('figure').draggable();
  } else {
    console.log('touch');
  }

  $(container).on('mousedown', function() {
    isDragging = false;
  }).on('mousemove', function() {
      isDragging = true;
  }).on('mouseup', function(e) {
    var wasDragging = isDragging;
    isDragging = false;
    if (wasDragging) {
      // what a drag!
    } else {
      // remove active class from last one
      $('figure.active').removeClass('active');

      // reset
      if (current >= list) {
        current = 0;
      }
    
      // get coordinates
      x = e.pageX + 'px';
      y = e.pageY + 'px';
    
      // assign placement to image
      $(e.currentTarget).find(`.media-${current}`).addClass('active')
        .css({
          'top': y,
          'left': x,
          'opacity': '1',
          'transform': 'none',
          'z-index': clicks,
          'object-position': 'top left',
        }
      );
      
      // increment
      current++;
      clicks++;
    }
  });
}